import { SVGProps } from 'react';

/**
 * SVG Icon Components
 * Each icon is a 512x512 viewBox SVG
 */

export const seafoodIcons: Record<string, React.FC<SVGProps<SVGSVGElement>>> = {
  fish: (props) => (
    <svg viewBox="0 0 68 68" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path
          d="m3.6 33.2c-.8 1-.8 2.5 0 3.5 4.1 5.4 9.1 8.1 13.7 9.4 5.4 1.5 10.3 1.1 12.6.8.9-.1 1.9 0 2.7.5l5.9 3.2c1.1.6 2.2-.5 1.7-1.6l-.8-1.7c-.5-1 .1-2.2 1.1-2.6 3.5-1.2 6.9-3.2 9.1-4.7 1.5-1 3.4-.9 4.8.2 2.2 1.7 5.6 3.2 8.2 4.2 1.1.4 2.2-.9 1.5-1.9l-4.4-6.5c-.4-.5-.3-1.3.3-1.7 2.6-2 4.1-5.4 5-7.9.4-1.1-.8-2.1-1.8-1.5l-8.7 5.2c-1.2.7-2.6.8-3.8.2l-13.2-5.9c-1-.5-1.5-1.6-1.1-2.6l1.2-3c.5-1.1-.8-2.2-1.8-1.5l-7.2 4.3c-.8.5-1.7.6-2.5.6-2.7-.2-5.2.1-7.5.7-7.7 2-12.8 7.4-15 10.3z"
          fill="#f95353"
        />
        <path
          d="m3.7 36.8c4.1 5.3 9 8 13.6 9.4 3.7-2.8 6.1-7.2 6.1-12.2 0-4.4-1.8-8.3-4.8-11-7.8 2-12.8 7.4-15 10.3-.8.9-.8 2.4.1 3.5z"
          fill="#efefef"
        />
        <path
          d="m15.7 34.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5z"
          fill="#fff"
        />
      </g>
      <path d="m38.5 19.3c.4-.9.1-1.9-.6-2.6-.7-.6-1.8-.7-2.6-.2l-7.2 4.3c-.6.3-1.2.5-1.9.4-2.7-.2-5.2.1-7.8.7-6.2 1.6-11.6 5.5-15.6 10.6-1.1 1.4-1.1 3.3 0 4.7v.1c6.5 8.4 16.5 12 27.1 10.6.7-.1 1.4 0 2.1.3l5.9 3.2c.3.2.7.3 1.1.3 1.5 0 2.7-1.6 2.1-3.2l-.8-1.7c-.2-.5 0-1 .5-1.2 3.9-1.3 7.6-3.6 9.3-4.8 1.1-.7 2.6-.7 3.6.2 2.3 1.8 5.9 3.4 8.5 4.4.9.4 1.9.1 2.6-.7.6-.8.7-1.8.1-2.7l-4.4-6.6c-.1-.1-.1-.2 0-.3 2.8-2.1 4.4-5.7 5.3-8.3.3-.9 0-1.9-.7-2.5s-1.8-.7-2.6-.2l-8.7 5.2c-.9.5-2 .6-2.9.2l-13.2-5.9c-.5-.2-.7-.8-.5-1.3zm-21.4 25.7c-5-1.6-9.3-4.5-12.6-8.9-.5-.7-.6-1.7 0-2.4 3.5-4.5 8.3-8.2 14-9.8 2.6 2.6 4 6.2 4 9.9-.1 4.4-2.1 8.5-5.4 11.2zm33-13.6c1.5.7 3.3.6 4.7-.3l8.7-5.2c.1-.1.2 0 .3 0 .2.1.2.2.2.3-.8 2.4-2.3 5.6-4.6 7.4-.9.7-1.1 2-.5 3l4.4 6.6c.1.1.1.2 0 .3s-.2.1-.3.1c-2.4-.9-5.8-2.4-7.9-4.1-1.7-1.4-4.1-1.5-6-.2-1.7 1.2-5.1 3.3-8.9 4.6-.8.3-1.4.8-1.7 1.6-.3.7-.3 1.6 0 2.3l.8 1.7c0 .1 0 .2-.1.3s-.2.1-.3 0l-5.9-3.3c-1-.5-2.2-.7-3.3-.6-2 .3-5.9.6-10.3-.3 3.2-3 5-7.3 5-11.7 0-3.8-1.4-7.5-3.8-10.4 1.8-.3 3.6-.4 5.4-.3 1.1.1 2.2-.2 3.1-.7l7.2-4.3c.1-.1.2-.1.3 0s.1.2.1.3l-1.2 3c-.6 1.5.1 3.2 1.6 3.9z" />
      <path d="m28.4 27.7c-.6 0-1 .4-1 1s.4 1 1 1 1 .5 1 1.1-.5 1-1 1c-.6 0-1 .5-1 1s.5 1 1 1c1.7 0 3-1.4 3-3-.1-1.7-1.4-3.1-3-3.1z" />
      <path d="m28.4 36.7c-.6 0-1 .4-1 1s.4 1 1 1 1 .5 1 1.1-.5 1-1 1c-.6 0-1 .5-1 1s.5 1 1 1c1.7 0 3-1.4 3-3-.1-1.8-1.4-3.1-3-3.1z" />
      <path d="m34.3 28.7c0 .6.4 1 1 1s1 .5 1 1.1-.5 1-1 1c-.6 0-1 .5-1 1s.5 1 1 1c1.7 0 3-1.4 3-3 0-1.7-1.3-3-3-3.1-.6 0-1 .4-1 1z" />
      <path d="m35.3 36.7c-.6 0-1 .4-1 1s.4 1 1 1 1 .5 1 1.1-.5 1-1 1c-.6 0-1 .5-1 1s.5 1 1 1c1.7 0 3-1.4 3-3 0-1.8-1.3-3.1-3-3.1z" />
      <path d="m42.2 35.7c-.6 0-1 .5-1 1s.5 1 1 1c1.7 0 3-1.4 3-3 0-1.7-1.3-3-3-3.1-.6 0-1 .4-1 1s.4 1 1 1 1 .5 1 1.1-.5 1-1 1z" />
      <path d="m13.2 31c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5zm0 5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z" />
    </svg>
  ),
  shrimp: (props) => (
    <svg viewBox="0 -24 512.00033 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="#ff9a5c">
        <path d="m353.765625 158.875c13.1875-.519531 26.867187-.855469 40.101563 1.324219 29.589843 4.878906 55.761718 17.449219 73.53125 42.230469 3.59375 5.011718 10.570312 6.164062 15.582031 2.570312 4.578125-3.28125 5.929687-9.386719 3.398437-14.238281-8.109375-15.527344-18.0625-28.699219-32.089844-39.421875-28.253906-21.597656-64.457031-33.292969-99.84375-34.839844zm0 0" />
        <path d="m296.9375 199.132812c2.757812.375 6.132812.835938 10.019531 1.523438 12.394531 2.195312 24.492188 5.289062 36.574219 8.800781 32.355469 9.398438 63.300781 26.785157 86.695312 51.140625 11.195313 11.65625 19.308594 25.566406 26.140626 40.121094 2.621093 5.585938 9.273437 7.988281 14.859374 5.367188 5.257813-2.46875 7.675782-8.558594 5.75-13.921876-6.347656-17.679687-14.371093-34.207031-26.105468-48.980468-22.507813-28.335938-52.71875-49.183594-85.3125-64.304688-8.84375-4.105468-17.914063-7.578125-27.105469-10.808594zm0 0" />
        <path d="m378.125 48.21875c13.1875.519531 26.871094.855469 40.101562-1.328125 29.589844-4.875 55.761719-17.445313 73.53125-42.230469 3.59375-5.011718 10.570313-6.160156 15.582032-2.566406 4.578125 3.28125 5.933594 9.382812 3.398437 14.234375-8.109375 15.53125-18.0625 28.703125-32.089843 39.425781-28.253907 21.59375-64.457032 33.289063-99.84375 34.835938zm0 0" />
        <path d="m155.261719 340.886719c70.378906 50.023437 93.253906-29.839844 159.449219-29.839844 20.566406-1.144531 37.597656 15.191406 37.597656 35.503906 0 11.746094-5.699219 22.15625-14.480469 28.628907-5.820313 4.292968-4.933594 10.203124-5.519531 16.496093-1.5625 16.828125-15.078125 30.425781-31.902344 32.0625-7.308594.707031-13.109375 4.691407-14.558594 12.085938-2.582031 13.167969-12.453125 23.65625-25 27.3125-3.386718.988281-6.925781 1.328125-10.453125 1.277343-92.507812-1.339843-118.519531-59.882812-118.519531-59.882812zm0 0" />
      </g>
      <path
        d="m190.796875 252.167969h.011719c8.386718-15.015625 21.5625-27.40625 38-34.632813l-77.8125-204.914062c-59.425782 18.25-108.304688 61.863281-133.183594 117.996094v101.949218l66.398438 38.65625zm0 0"
        fill="#ffbd73"
      />
      <path
        d="m365.558594 178.878906c4.191406 1.941406 8.339844 3.984375 12.441406 6.121094-8.175781 8.015625-17.09375 15.289062-26.742188 21.753906-1.75 1.175782-3.527343 2.316406-5.324218 3.4375-.800782-.242187-1.597656-.503906-2.402344-.734375-12.082031-3.511719-24.179688-6.605469-36.574219-8.800781-3.882812-.6875-7.261719-1.148438-10.019531-1.523438l41.515625-31.0625c9.191406 3.230469 18.261719 6.703126 27.105469 10.808594zm0 0"
        fill="#ff7e27"
      />
      <path
        d="m416.839844 130.078125c-2.519532 5.316406-5.308594 10.621094-8.394532 15.871094-3.070312 5.226562-6.371093 10.257812-9.867187 15.105469-1.5625-.304688-3.128906-.59375-4.710937-.851563-13.234376-2.183594-26.914063-1.847656-40.101563-1.328125l.679687-42.371094c21.128907.921875 42.546876 5.464844 62.394532 13.574219zm0 0"
        fill="#ff7e27"
      />
      <path
        d="m418.226562 46.890625c7.066407-1.164063 13.933594-2.773437 20.542969-4.875-.75 11.527344-2.308593 24.378906-5.183593 37.902344-17.652344 6.292969-36.328126 9.867187-54.78125 10.671875l-.679688-42.371094c13.1875.519531 26.871094.855469 40.101562-1.328125zm0 0"
        fill="#ff7e27"
      />
      <path
        d="m147.820312 49.554688c0 68.015624 31.625 128.648437 80.988282 167.980468 6.554687-2.890625 13.621094-4.953125 21.117187-6.035156 140.894531-20.398438 157.933594-134.589844 158.503907-184.664062.148437-12.953126-10.273438-23.542969-23.234376-23.542969h-172.03125c-21.5625 0-42.449218 3.261719-62.167968 9.328125-2.097656 12-3.175782 24.339844-3.175782 36.933594zm0 0"
        fill="#ff9a5c"
      />
      <path
        d="m150.996094 12.621094 5.550781 14.617187c-43.09375 22.375-77.832031 58.945313-97.527344 103.378907-16.214843 36.589843-21.4375 77.554687-15.238281 117.066406l-25.96875-15.117188v-101.949218c15.457031-34.871094 40.472656-65.277344 71.488281-87.441407 18.609375-13.300781 39.410157-23.710937 61.695313-30.554687zm0 0"
        fill="#ff9a5c"
      />
      <path
        d="m0 215.039062c.0859375 46.039063 14.878906 88.625 39.960938 123.300782 83.65625 19.792968 143.074218-23.109375 144.152343-23.894532v-.011718c-6.734375-21.605469-3.597656-43.898438 6.683594-62.261719-1.554687-.140625-138.105469-12.234375-172.984375-121.554687-11.488281 25.894531-17.8632812 54.457031-17.8125 84.421874zm0 0"
        fill="#ff9a5c"
      />
      <path
        d="m241.253906 341.8125c22.851563 23.03125 26.003906 60.011719 6.546875 86.6875-11.921875 16.335938-30.710937 26.429688-50.769531 27.445312-49.640625-16.523437-65.15625-51.417968-65.15625-51.417968l23.386719-63.640625c37.609375 26.730469 61.652343 16.367187 85.992187.925781zm0 0"
        fill="#ff7e27"
      />
      <path
        d="m15.722656 135.503906c.675782-1.640625 1.375-3.269531 2.09375-4.886718 6.105469 19.136718 15.332032 35.285156 26.398438 48.921874-1.984375 11.550782-3.027344 23.410157-3.007813 35.5.082031 45.933594 15.648438 91.890626 43.863281 128.503907-13.992187.070312-29.105468-1.417969-45.109374-5.203125-6.269532-8.671875-11.894532-17.832032-16.8125-27.421875-27.691407-54.019531-30.652344-119.261719-7.425782-175.414063zm0 0"
        fill="#ff7e27"
      />
      <path
        d="m39.960938 338.339844c34.484374 47.710937 88.414062 80.445312 150.160156 86.613281 1.195312.113281 2.382812.179687 3.566406.179687 11.449219 0 22.316406-5.488281 29.148438-14.851562 11.132812-15.257812 8.652343-36.570312-5.761719-48.789062-14.878907-12.636719-24.402344-26.003907-30.109375-39.335938-1.09375-2.554688-2.035156-5.128906-2.851563-7.710938zm0 0"
        fill="#ffbd73"
      />
      <path
        d="m39.960938 338.339844 36.945312-6.125c1.386719 2.066406 2.804688 4.109375 4.261719 6.125 30.308593 41.9375 75.648437 72.296875 128.097656 83.222656-1.199219.574219-2.429687 1.085938-3.683594 1.527344-.011719.003906-.023437.007812-.035156.011718-4.875 1.785157-10.273437 2.363282-15.429687 1.851563-28.941407-2.890625-56.167969-11.617187-80.480469-24.992187-27.21875-14.976563-51.363281-36.285157-69.675781-61.621094zm0 0"
        fill="#ff9a5c"
      />
      <path
        d="m254.367188 3.292969c-21.5625 0-42.445313 3.261719-62.164063 9.332031-15.324219 4.703125-29.941406 11.109375-43.636719 18.972656.53125-6.410156 1.339844-12.738281 2.429688-18.972656 7.398437-2.277344 14.953125-4.15625 22.652344-5.621094 13.019531-2.46875 26.265624-3.710937 39.519531-3.710937zm0 0"
        fill="#ff7e27"
      />
      <path
        d="m317.675781 79.824219c4.265625 0 7.726563-3.460938 7.726563-7.726563v-17.375c0-4.269531-3.460938-7.726562-7.726563-7.726562-4.269531 0-7.726562 3.457031-7.726562 7.726562v17.375c0 4.265625 3.457031 7.726563 7.726562 7.726563zm0 0"
        fill="#333941"
      />
      <path
        d="m293.085938 107.257812h14.667968c4.269532 0 7.726563-3.460937 7.726563-7.726562 0-4.269531-3.457031-7.726562-7.726563-7.726562h-14.667968c-4.269532 0-7.726563 3.457031-7.726563 7.726562 0 4.265625 3.457031 7.726562 7.726563 7.726562zm0 0"
        fill="#ff5f7f"
      />
    </svg>
  ),
  seafood: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m160 248 31.716-19.5c8.43-5.717 10.893-18.358 5.213-27.426-16.515-26.359-49.381-49.074-84.929-49.074s-68.414 22.715-84.929 49.077c-5.68 9.068-3.217 21.709 5.213 27.426l31.716 19.497z"
        fill="#d49073"
      ></path>
      <path d="m112 256a8 8 0 0 1 -8-8v-40a8 8 0 0 1 16 0v40a8 8 0 0 1 -8 8z" fill="#ad6643"></path>
      <path
        d="m135.994 256a8 8 0 0 1 -7.149-11.58l16-32a8 8 0 0 1 14.31 7.156l-16 32a8 8 0 0 1 -7.161 4.424z"
        fill="#ad6643"
      ></path>
      <path
        d="m88.006 256a8 8 0 0 1 -7.161-4.424l-16-32a8 8 0 1 1 14.31-7.156l16 32a8 8 0 0 1 -7.149 11.58z"
        fill="#ad6643"
      ></path>
      <g fill="#ed8424">
        <path d="m224 96a40.045 40.045 0 0 1 -40-40v-16a8 8 0 0 1 16 0v16a24.027 24.027 0 0 0 24 24 8 8 0 1 1 0 16z"></path>
        <path d="m205.513 124.578a40.77 40.77 0 0 1 -7.4-.664 33.125 33.125 0 0 1 -24.205-18.025 7.706 7.706 0 0 1 -.386-.908l-5.064-14.311a8 8 0 1 1 15.082-5.34l4.888 13.807a17.014 17.014 0 0 0 12.592 9.043c5.906 1.091 12.979-.125 19.4-3.335a8 8 0 1 1 7.157 14.31 49.7 49.7 0 0 1 -22.064 5.423z"></path>
        <path d="m232 208h16a48 48 0 0 1 48 48 0 0 0 0 1 0 0h-16a48 48 0 0 1 -48-48 0 0 0 0 1 0 0z"></path>
        <path d="m280 256h16a0 0 0 0 1 0 0 48 48 0 0 1 -48 48h-16a0 0 0 0 1 0 0 48 48 0 0 1 48-48z"></path>
      </g>
      <path
        d="m392 272h-92.021a20.93 20.93 0 0 1 0-41.816l92.869-5.365a24.417 24.417 0 0 0 23.569-24.4 24.417 24.417 0 0 0 -24.417-24.419h-80a96 96 0 0 1 -96-96h176a96 96 0 0 1 96 96c0 53.019-32 96-96 96z"
        fill="#ff8e26"
      ></path>
      <path
        d="m432.02 265.23c-11.55 4.37-24.89 6.77-40.02 6.77h-40s-24.36-19.88-16.36-43.88l57.21-3.3a24.494 24.494 0 0 0 7.2-1.34c.01 0 .03-.01.04-.01.57 6.35 4.63 34.2 31.93 41.76z"
        fill="#ff750a"
      ></path>
      <path
        d="m431.99 88.7c-.39 55.57-47.99 87.3-47.99 87.3h-72a96 96 0 0 1 -96-96h176a95.573 95.573 0 0 1 39.99 8.7z"
        fill="#ff8e26"
      ></path>
      <path
        d="m487.99 175.34c-.32.12-24.19 32.42-71.58 24.72a24.4 24.4 0 0 0 -24.41-24.06h-8s47.6-31.73 47.99-87.3a95.985 95.985 0 0 1 56 86.64z"
        fill="#ff750a"
      ></path>
      <circle cx="272" cy="112" fill="#ff750a" r="8"></circle>
      <path
        d="m312.006 176a8 8 0 0 1 -3.646-15.126 34.1 34.1 0 0 0 7.492-6.049 55.533 55.533 0 0 0 12.558-21.356 8 8 0 0 1 15.18 5.059c-8.945 26.835-27.238 36.238-28.012 36.626a7.971 7.971 0 0 1 -3.572.846z"
        fill="#ff750a"
      ></path>
      <path
        d="m24 312h16a80 80 0 0 1 80 80 0 0 0 0 1 0 0h-16a80 80 0 0 1 -80-80 0 0 0 0 1 0 0z"
        fill="#c3c6c7"
        transform="matrix(-1 0 0 -1 144 704)"
      ></path>
      <path
        d="m104 392h16a0 0 0 0 1 0 0 80 80 0 0 1 -80 80h-16a0 0 0 0 1 0 0 80 80 0 0 1 80-80z"
        fill="#c3c6c7"
        transform="matrix(-1 0 0 -1 144 864)"
      ></path>
      <path
        d="m352 312c104 24 136 80 136 80s-32 56-136 80a501.446 501.446 0 0 1 -88 8c-48 0-93.6-15.617-136-42.651a53.8 53.8 0 0 1 -24.928-45.349 53.8 53.8 0 0 1 24.928-45.349c42.4-27.034 88-42.651 136-42.651a501.446 501.446 0 0 1 88 8z"
        fill="#dadcde"
      ></path>
      <path
        d="m488 392s-25.37 44.4-104.36 71.07c-2.38-6.18-15.64-41.94-15.64-71.07s13.26-64.89 15.64-71.07c78.99 26.67 104.36 71.07 104.36 71.07z"
        fill="#c3c6c7"
      ></path>
      <circle cx="432" cy="384" fill="#9aa3a8" r="8"></circle>
      <path
        d="m277.72 392c0 22.4 10.28 33.6 10.28 33.6l-61.71 22.4s-8.68-18.89-10.09-48q-.195-3.885-.2-8t.2-8c1.41-29.11 10.09-48 10.09-48l61.71 22.4s-10.28 11.2-10.28 33.6z"
        fill="#c3c6c7"
      ></path>
      <path
        d="m240 392a8 8 0 0 1 -8 8h-15.8q-.195-3.885-.2-8t.2-8h15.8a8 8 0 0 1 8 8z"
        fill="#9aa3a8"
      ></path>
      <path
        d="m64 248h96v24a16 16 0 0 1 -16 16c-8 0-16-8-32-8s-24 8-32 8a16 16 0 0 1 -16-16z"
        fill="#b37a60"
      ></path>
    </svg>
  ),
  calamar: (props) => (
    <svg
      id="fi_7593170"
      height="512"
      viewBox="0 0 463.916 463.916"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m363.428 382.51c-19.534 9.635-41.867 9.502-62.34 3.391 6.873 17.128 20.845 30.394 38.9 34.5 15.475 3.53 13.076 26.34-2.63 26.34-15.245 0-35.521-5.291-50.21-17.035 19.08 15.189-2.276 44.538-22.23 30.515-15.24-10.71-29.38-34.05-32.96-75.75-3.58 41.7-17.72 65.04-32.96 75.75-19.95 14.03-41.31-15.33-22.23-30.51-12.31 9.8-29.17 16.193-49.54 17.021-16.26.661-19.009-22.766-3.3-26.33 18.451-4.186 32.02-17.37 38.9-34.5-12.83 3.83-37.9 8.659-62.34-3.391-90.85-44.779-23.724-189.594-37.02-208.1-4.168-5.801-3.91-13.71.08-19.641 9.39-13.939 31.27-8.17 32.32 8.601 3.76 59.89-42.55 186.38 38.91 186.38 20.83 0 34.55-10.69 36.32-41.11 26.831-48.015 95.012-47.936 121.72-.01 1.77 30.42 15.49 41.12 36.32 41.12 81.46 0 35.15-126.49 38.91-186.38 1.05-16.771 22.934-22.543 32.32-8.601 3.992 5.93 4.248 13.839.08 19.641-13.296 18.505 53.83 163.32-37.02 208.099z"
        fill="#ff8c95"
      ></path>
      <g fill="#ffaeb5">
        <path d="m343.558 354.5c-7.87 0-14.72-1.52-20.3-5.07 1.89.221 3.85.32 5.88.32 81.46 0 35.15-126.49 38.91-186.38.97-15.44 19.59-21.561 29.87-11.53-7.78.98-14.87 6.91-15.45 16.28-3.76 59.89 42.55 186.38-38.91 186.38z"></path>
        <path d="m169.877 419.32c-8.227 12.926-20.501 23.697-42.649 27.411-16.26.659-19.01-22.771-3.3-26.33 10.779-2.451 19.892-7.966 26.981-15.551 9.445-10.105 26.91 1.992 18.968 14.47z"></path>
        <path d="m130.638 349.63c27.556 1.647 38.861-13.511 40.46-40.99 0-.1 9.104 1.997 25.13 3.74 5.335 52.425-47.629 51.674-65.59 37.25z"></path>
        <path d="m99.408 381.96c-89.23-45.39-22.7-189.11-35.94-207.55-4.17-5.8-3.91-13.71.08-19.641 10.762-15.979 35.235-5.35 31.389 13.458-6.199 30.315-43.671 139.742 4.471 213.733z"></path>
      </g>
      <path
        d="m313.958 373.97c1.49 5.471 3.91 10.98 7.38 15.84-8.14-.71-15.16-2.39-20.25-3.909-1.01-2.5-1.87-5.08-2.59-7.73-2.73-10.111 12.69-14.351 15.46-4.201z"
        fill="#ff6d7a"
      ></path>
      <path
        d="m292.858 452.16c-18.696-9.248-32.127-23.994-39.06-40.62-4.06-9.74 10.6-16.16 14.76-6.14 6.67 16.08 18.59 23.977 18.59 24.305 8.04 6.401 8.9 15.325 5.71 22.455z"
        fill="#ff6d7a"
      ></path>
      <path
        d="m171.058 452.16c18.696-9.248 32.127-23.994 39.06-40.62 4.06-9.74-10.6-16.16-14.76-6.14-6.67 16.08-18.59 23.982-18.59 24.31-8.04 6.401-8.9 15.32-5.71 22.45z"
        fill="#ff6d7a"
      ></path>
      <path
        d="m149.958 373.97c-1.49 5.471-3.91 10.98-7.38 15.84 8.14-.71 15.16-2.39 20.25-3.909 1.01-2.5 1.87-5.08 2.59-7.73 2.73-10.111-12.69-14.351-15.46-4.201z"
        fill="#ff6d7a"
      ></path>
      <circle cx="254.378" cy="345.19" fill="#e84857" r="8"></circle>
      <circle cx="209.538" cy="345.19" fill="#e84857" r="8"></circle>
      <path
        d="m246.138 11.24c74.11 52.72 122.57 116.029 52.43 126.99-32.176-32.517-52.28-77.573-52.43-126.99z"
        fill="#e84857"
      ></path>
      <path
        d="m217.778 11.24c4.462 49.094-15.55 96.068-52.43 126.99-70.14-10.96-21.68-74.27 52.43-126.99z"
        fill="#e84857"
      ></path>
      <path
        d="m309.668 287.49c-.959 11.242-8.538 19.629-17.51 21.28-39.885 7.337-80.515 7.337-120.4 0-8.988-1.654-16.553-10.059-17.51-21.28-8.61-100.435 15.133-200.071 66.46-280.95 5.52-8.72 16.98-8.72 22.5 0 49.806 78.483 75.318 177.625 66.46 280.95z"
        fill="#ff6d7a"
      ></path>
      <path
        d="m244.012 24.554c-10.2 19.521-31.612 69.561-40.774 130.766-7.3 48.859-6.75 99.489 2.03 149.66.54 3.09 1.58 5.96 3.03 8.5-12.22-.881-24.42-2.45-36.54-4.711-8.756-1.555-16.534-9.841-17.51-21.28-8.859-103.334 16.657-202.469 66.46-280.95 5.52-8.72 16.98-8.72 22.5 0 3.564 5.617 3.717 12.441.804 18.015z"
        fill="#ff8c95"
      ></path>
    </svg>
  ),
  salmon: (props) => (
    <svg
      id="fi_12717149"
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m280.932 173.719-254.167 146.747c1.398 4.818-4.595 6.954 0 9.608l161.562 93.28c4.595 2.653 12.045 2.653 16.64 0l238.142-137.495c8.335-4.813 16.759-15.914 19.816-21.049l-165.354-91.091c-4.595-2.653-12.044-2.653-16.639 0z"
          fill="#a87368"
        ></path>
        <path
          d="m447.521 177.929c-20.471-12.474-41.581-24.006-62.341-35.992-20.78-11.998-41.562-23.995-62.342-35.994-10.39-5.999-20.774-12.007-31.163-18.006-10.78-6.224-21.543-13.179-34.449-13.278-21.928-.169-43.379 14.564-59.79 27.637-18.207 14.504-35.849 32.219-47.053 52.832-7.236 13.312-12.81 27.507-20.084 40.842-7.1 13.018-14.857 25.684-23.364 37.831-12.547 17.915-26.734 34.799-42.908 49.557-5.318 4.852-10.855 9.474-16.644 13.756-3.758 2.779-7.679 5.325-11.242 8.363-3.558 3.035-8.555 7.272-9.724 12.077-.829 3.41 2.026 4.232 4.502 5.66 5.383 3.108 10.894 5.954 16.276 9.062 10.36 5.981 20.592 12.225 30.953 18.206 20.641 11.916 41.343 23.701 61.979 35.616 10.39 5.999 20.781 11.998 31.171 17.997 5.208 3.007 10.483 5.884 15.695 8.894 2.52 1.455 5.015 2.923 7.557 4.363 2.698 1.528 4.477 1.003 7.457-.546 4.157-2.161 8.157-4.68 12.213-7.021 24.691-14.256 49.382-28.512 74.073-42.768 32.234-18.611 64.468-37.222 96.702-55.832 21.989-12.696 43.978-25.391 65.966-38.087 6.456-3.728 12.14-7.243 16.248-13.901 10.453-16.943 9.829-40.758 1.459-58.367-4.559-9.588-11.803-17.767-21.147-22.901z"
          fill="#fb8249"
        ></path>
        <g fill="#ffb889">
          <path d="m129.897 305.475c1.38-7.321.165-14.807.47-22.173.57-13.771 5.031-26.987 9.362-39.941 8.08-24.167 17.217-48.053 29.063-70.649 21.803-41.59 53.591-79.52 98.037-96.722-3.084-.81-6.27-1.305-9.603-1.331-9.104-.07-18.12 2.45-26.734 6.332-18.26 11.755-34.566 26.432-47.655 43.431-28.203 36.628-45.678 81.584-58.362 125.709-3.114 10.834-5.737 21.857-6.017 33.171-.276 11.193 3.148 23.945-9.576 28.792-20.666 7.873-42.891 12.228-64.362 18.693.89.499 1.79.978 2.674 1.488 2.551 1.473 5.083 2.986 7.623 4.484 17.185-4.954 34.689-9.412 51.791-12.953 12.813-2.652 20.601-4.068 23.289-18.331z"></path>
          <path d="m156.235 329.568c4.031-17.591.063-37.887 2.796-56.009 3.406-22.581 10-44.666 19.892-65.263 19.383-40.36 51.649-76.357 94.564-91.753 17.001-6.1 33.456-9.314 49.729-10.381-.126-.073-.252-.145-.378-.218-6.378-3.682-12.754-7.368-19.13-11.053-2.094.388-4.17.784-6.182 1.2-41.99 8.68-77.427 30.536-103.99 64.254-26.567 33.723-42.354 74.483-47.805 116.905-1.106 8.613-2.014 17.358-1.974 26.049.06 13.035 3.196 22.526-10.052 28.535-17.632 7.997-37.605 12.445-56.771 17.936.406.235.807.479 1.213.714 3.746 2.163 7.5 4.309 11.25 6.465 14.687-4.429 29.489-8.573 44.253-12.246 11.507-2.865 19.676-2.44 22.585-15.135z"></path>
          <path d="m459.711 267.434c2.842-2.22 5.381-4.809 7.497-8.238.095-.154.173-.319.266-.474-44.08-43.197-109.862-58.516-161.019-13.396-37.919 33.444-55.384 88.272-45.59 137.525 2.566-1.482 5.134-2.964 7.7-4.446-1.996-43.041 10.948-88.334 41.826-118.446 22.282-21.729 54.297-33.785 85.398-27.699 24.534 4.801 44.549 19.893 63.922 35.174z"></path>
          <path d="m368.702 173.472c-55.513 11.973-98.978 65.965-121.412 115.22-13.278 29.152-19.22 59.287-27.846 89.827-1.01 3.576-1.94 12.947-3.915 15.932-4.269 6.455-15.604 5.888-22.713 7.506-6 1.365-11.393 2.889-16.492 4.987 3.56 2.006 7.124 4 10.667 6.045.201.116.402.232.602.348 9.513-1.851 19.154-3.124 28.772-4.793 3.508-2.026 7.016-4.051 10.524-6.076.053-.266.145-.53.174-.795 1.418-12.922 7.501-24.859 10.266-37.523 2.442-11.185 4.214-22.389 7.725-33.319 7.133-22.202 16.703-44.261 29.142-64.031 25.432-40.421 64.125-76.864 113.136-82.425 21.063-2.39 45.326-3.71 68.406-.66-2.524-2.191-5.252-4.156-8.217-5.785-5.922-3.608-11.904-7.127-17.909-10.611-21.574-.252-42.868 2.262-60.91 6.153z"></path>
          <path d="m178.807 394.244c10.53-.833 25.939-1.9 31.485-12.711 2.453-4.781 1.226-9.998.744-15-1.292-13.391-1.081-25.72.282-39.167 2.95-29.094 11.608-54.699 26.551-79.916 13.264-22.383 31.27-45.609 53.438-59.917 20.963-13.531 46.407-18.726 70.642-22.887 18.053-3.101 36.04-5.246 53.734-5.337-7.307-4.158-14.62-8.304-21.918-12.466-2.341.225-4.716.43-6.991.689-46.858 5.334-92.997 14.794-126.964 49.635-34.809 35.705-56.601 80.725-61.547 130.201-1.09 10.901-1.396 21.48-1.51 32.397-.111 10.773 3.171 16.017-7.136 20.146-4.824 1.933-13.004 1.488-18.331 1.82-10.193.636-19.464 2.786-28.314 6.011 5.388 3.111 10.776 6.222 16.164 9.332 6.324-1.275 12.805-2.287 19.671-2.83z"></path>
          <path d="m27.049 320.713c.9 1.038 2.437 1.675 3.869 2.501.972.561 1.96 1.089 2.939 1.636 7.036-2.794 14.001-7.558 18.841-9.988 15.869-7.969 43.615-8.993 51.648-26.697 4.166-9.182 3.954-20.359 5.807-30.147 3.108-16.421 7.682-32.825 12.732-48.748.08-.252.175-.497.255-.749-5.089 8.623-10.463 17.077-16.207 25.279-1.86 2.656-3.832 5.236-5.766 7.843-.758 3.189-1.576 6.359-2.268 9.567-1.538 7.123-2.49 14.104-3.302 21.344-2.077 18.536-17.234 21.428-32.565 27.911-8.19 3.463-24.016 15.836-35.983 20.248z"></path>
          <path d="m150.482 369.572c9.058-2.381 22.036-2.394 27.443-10.945 8.26-13.062 6.317-41.785 7.919-56.684 2.936-27.294 5.677-54.727 19.083-79.186 20.195-36.841 60.774-71.388 101.224-83.877 22.232-6.864 46.919-2.757 69.933-2.196-9.012-5.203-18.022-10.405-27.034-15.608-10.137-.164-20.16.145-29.753 1.288-37.921 4.519-75.262 32.833-100.601 60.084-31.983 34.396-40.284 74.091-44.914 119.495-1.288 12.628.679 36.302-5.633 46.719-1.348 2.226-2.187 3.748-2.72 4.832-.104.081-.17.121-.285.212-3.558 2.84-12.915 3.327-17.743 4.69-12.235 3.453-24.996 6.29-37.095 10.566 4.134 2.37 8.264 4.751 12.396 7.123 9.245-2.294 18.666-4.117 27.78-6.513z"></path>
        </g>
        <path
          d="m431.164 172.238c-36.614-6.473-99.839 50.32-115.391 85.507-37.947 85.861-83.483 124.972-104.734 139.645-21.25 14.673-20.249 25.921-8.326 19.037l254.167-146.748c27.329-15.778 27.011-88.119-25.716-97.441z"
          fill="#eb4715"
        ></path>
        <g fill="#fc7356">
          <path d="m431.164 172.238c-11.202-1.981-24.896 1.979-38.952 9.411 30.956 6.358 66.629-7.065 67.972 38.2.586 19.746-4.606 38.269-13.089 55.479l9.784-5.649c7.224-4.171 12.492-12.311 15.395-22.177 1.529-7.892 2.335-15.762 2.364-23.451-1.68-23.088-14.83-46.749-43.474-51.813z"></path>
          <path d="m318.128 323.442c1.584-27.462 6.665-62.692 18.657-87.908 1.356-2.85.424-5.51-1.385-7.116-8.772 10.242-15.712 20.469-19.627 29.326-.371.84-.748 1.646-1.121 2.477-1.448 5.529-2.674 11.142-3.744 16.716-12.353 18.569-26.904 39.089-29.354 61.254-.941 8.512-.94 20.98 1.467 31.866l9.5-5.485c-2.132-14.065.655-31.968 3.769-40.098 2.389-6.239 5.848-11.951 9.476-17.563-2.427 15.76-4.207 33.828.373 47.97.171.527.416.97.603 1.48l11.935-6.891c-2.195-7.836-1.067-17.046-.549-26.028z"></path>
          <path d="m273.654 369.842c-.558-10.377-.633-21.68-3.792-31.621-.009-.029-.03-.049-.04-.078-3.603 4.875-7.162 9.428-10.658 13.672-.01 1.904.003 3.908.055 6.012-7.056 7.996-13.255 19.284-17.704 28.232-1.641 3.3-2.857 6.627-3.441 9.95l12.606-7.278c2.449-5.166 6.116-10.473 9.57-15.516.363 3.167.831 6.268 1.423 9.169l12.076-6.972c-.034-2.044-.011-3.996-.095-5.57z"></path>
          <path d="m444.605 240.169c2.106-34.618-28.247-54.858-61.204-46.136-34.631 9.165-50.729 58.291-55.64 89.338-1.732 10.949-3.86 42.206 4.939 58.005l10.331-5.965c-2.289-4.546-3.678-9.722-4.178-13.169-.967-6.679-1.279-13.177-1.093-19.934.347-12.597 2.553-24.337 6.573-36.254 8.676-25.715 20.874-61.171 53.592-60.914 39.621.311 35.2 37.628 25.753 64.038-3.678 10.28-8.487 19.242-13.927 27.712l23.267-13.434c6.564-14.395 10.749-29.504 11.587-43.287z"></path>
          <path d="m199.896 406.697c.725 2.629 3.318 5.74 5.611 8.117l19.895-11.486c.106-1.291.212-2.531.366-3.615.572-4.008 1.153-7.827 2.549-11.646.85-2.326 1.857-4.23 2.289-6.233-5.86 5.253-11.139 9.454-15.631 12.75-.329 2.598-.569 5.063-.852 7.143-.244 1.794-.487 3.586-.723 5.38 0 .008-.003.017-.003.025-1.73-2.115-4.743-4.228-6.509-5.579-.245-.188-.555-.303-.867-.411-2.448 1.959-4.484 3.821-6.125 5.555z"></path>
          <path d="m394.007 217.41c-42.58-.291-50.983 81.821-34.891 108.714l4.721-2.726c-7.49-14.794-3.578-33.927-.93-49.722 2.416-14.414 12.671-51.19 34.025-45.108 20.777 5.917 5.185 47.161.155 57.134-2.573 5.102-5.383 10.052-7.944 15.085 2.104-11.231 4.329-22.442 7.008-33.639 1.618-6.763 7.117-22.895-1.508-27.499-10.379-5.54-18.318 11.383-20.771 18.232-7.326 20.457-6.896 40.667-2.596 61.222l32.312-18.656c16.021-32.499 27.195-82.786-9.581-83.037zm-16.377 89.886c-.487 2.533-1.058 4.958-1.597 7.33-2.684-15.955-2.407-30.943 2.402-47.193 1.078-4.389 2.676-8.583 4.795-12.583 7.024-6.798 9.218-6.41 6.584 1.161.022 3.017-1.716 6.677-2.482 9.609-3.618 13.864-6.997 27.603-9.702 41.676z"></path>
        </g>
        <path
          d="m163.253 322.333c-12.725-10.295-24.486-21.665-34.384-27.868-13.767-8.629-22.088-15.014-17.708-33.083 3.918-16.161 13.924-32.925 20.749-48.084 8.447-18.763 17.158-36.806 29.277-53.464 20.456-28.117 41.42-52.697 77.824-57.771 37.163-5.18 72.808 18.938 94.476 46.171 7.249 9.11 8.146 16.544 6.783 28.233-3.683 31.581-42.569 50.391-60.057 75.202-10.195 14.463-21.508 30.541-28.504 46.823-6.508 15.147-6.493 25.672-20.449 37.035-22.543 18.355-46.634 4.097-68.007-13.194z"
          fill="#fbcab2"
          opacity=".2"
        ></path>
        <g fill="#fae9e1">
          <path d="m104.42 286.062c-2.463 1.331-3.184 3.878-4.259 6.321-1.371 3.119-2.741 5.442-6.318 6.275-.95.221-.77 1.841.235 1.737 6.772-.709 9.867-7.554 11.539-13.411.203-.704-.583-1.253-1.197-.922z"></path>
          <path d="m128.597 306.371c-1.877 2.685-.34 5.741-1.594 8.574-1.233 2.783-4.775 5.186-7.834 5.189-1.138.001-1.14 1.777 0 1.768 3.105-.026 6.145-1.922 8.116-4.249 2.741-3.237 1.077-7.114 2.43-10.809.253-.692-.745-1.006-1.118-.473z"></path>
          <path d="m154.307 329.765c-1.018 1.977-1.094 4.399-2.087 6.444-1.217 2.505-3.1 4.233-5.97 4.429-1.395.095-1.391 2.296 0 2.176 2.99-.257 5.36-1.656 6.969-4.206 1.382-2.19 2.84-5.813 2.609-8.432-.065-.74-1.118-1.192-1.521-.411z"></path>
          <path d="m179.553 353.929c-2.061 1.12-1.828 3.399-2.491 5.377-.885 2.641-3.789 4.062-6.03 5.388-.49.29-.32 1.201.309 1.141 2.591-.249 4.902-1.438 6.665-3.384.821-.906 1.352-1.922 1.727-3.077.455-1.4 1.038-2.805 1.418-4.216.253-.936-.771-1.678-1.598-1.229z"></path>
          <path d="m210.891 378.091c-2.244 2.702-4.676 5.569-6.286 8.694-.372.722.474 1.288 1.068.824 2.846-2.223 5.679-5.087 6.809-8.591.282-.874-.977-1.665-1.591-.927z"></path>
          <path d="m192.853 134.285c-7.318 6.083-11.191 15.439-15.558 23.636-.289.542.492.997.822.48 5.071-7.943 9.894-15.638 16.082-22.77.812-.933-.406-2.126-1.346-1.346z"></path>
          <path d="m217.338 152.652c-4.433 2.291-8.262 5.561-11.432 9.416-2.499 3.038-5.656 6.855-6.136 10.859-.063.524.714.812 1.045.433 2.851-3.265 4.635-7.285 7.701-10.51 3.053-3.212 6.434-6.047 9.893-8.809.818-.653-.223-1.827-1.071-1.389z"></path>
          <path d="m243.425 176.952c-7.703 2.447-14.656 10.138-17.728 17.451-.238.567.717.965.995.419 3.596-7.075 10.653-12.473 17.31-16.503.706-.428.253-1.631-.577-1.367z"></path>
          <path d="m268.983 206.196c-5.917 4.852-10.94 10.226-15.164 16.622-.252.382.337.848.641.494 4.871-5.668 10.606-10.489 15.485-16.155.577-.67-.288-1.514-.962-.961z"></path>
          <path d="m308.704 224.605c-8.297 4.452-14.499 11.282-20.023 18.814-.228.31.28.701.534.412 6.057-6.911 13.124-12.5 20.231-18.264.558-.454-.154-1.278-.742-.962z"></path>
          <path d="m314.827 254.838c-3.499 1.797-6.884 4.262-9.508 7.205-1.278 1.434.831 3.557 2.116 2.116 2.593-2.908 6.201-4.674 8.628-7.719.704-.883-.153-2.158-1.236-1.602z"></path>
        </g>
      </g>
    </svg>
  ),
  daurade: (props) => (
    <svg
      height="512"
      viewBox="0 0 511.059 511.059"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m254.374 310.012-57.751 61.26-2.987-3.616c-19.381-23.458-28.649-53.653-25.767-83.945l2.493-26.199z"
          fill="#6cabca"
        ></path>
        <path
          d="m165.878 331.707c-2.977 0-5.793-1.784-6.966-4.718-1.538-3.846.333-8.21 4.179-9.748l51.996-20.791c3.847-1.541 8.211.333 9.749 4.18 1.538 3.846-.333 8.21-4.179 9.748l-51.996 20.791c-.914.366-1.857.538-2.783.538z"
          fill="#b4d2e2"
        ></path>
        <path
          d="m177.703 361.056c-2.274 0-4.521-1.029-5.995-2.985-2.494-3.308-1.833-8.011 1.474-10.504l58.292-43.941c3.308-2.493 8.011-1.834 10.503 1.475 2.494 3.308 1.833 8.011-1.474 10.504l-58.292 43.941c-1.352 1.018-2.936 1.51-4.508 1.51z"
          fill="#b4d2e2"
        ></path>
        <path
          d="m193.12 382.487c-1.845 0-3.694-.677-5.143-2.043-3.014-2.841-3.154-7.588-.313-10.602l55.562-58.938c2.842-3.014 7.588-3.154 10.602-.312 3.014 2.841 3.154 7.588.313 10.602l-55.562 58.938c-1.475 1.565-3.465 2.355-5.459 2.355z"
          fill="#b4d2e2"
        ></path>
        <path
          d="m417.826 207.821-46.701-93.401h-17.653c-48.501 0-95.015 19.267-129.31 53.562l-39.839 39.839z"
          fill="#6cabca"
        ></path>
        <g fill="#b4d2e2">
          <path d="m404.942 189.542c-2.751 0-5.4-1.52-6.714-4.147l-36.224-72.448c-1.853-3.705-.351-8.21 3.354-10.062s8.21-.352 10.062 3.354l36.224 72.448c1.853 3.705.351 8.21-3.354 10.062-1.076.538-2.221.793-3.348.793z"></path>
          <path d="m283.308 184.22c-1.36 0-2.737-.37-3.975-1.146l-44.909-28.143c-3.51-2.2-4.572-6.828-2.373-10.338 2.2-3.511 6.828-4.571 10.338-2.373l44.909 28.143c3.51 2.2 4.572 6.828 2.373 10.338-1.424 2.273-3.866 3.519-6.363 3.519z"></path>
          <path d="m317.861 185.133c-1.69 0-3.39-.568-4.792-1.733l-54.59-45.396c-3.185-2.648-3.62-7.377-.971-10.562 2.648-3.186 7.377-3.618 10.562-.972l54.59 45.396c3.185 2.648 3.62 7.377.971 10.562-1.482 1.784-3.618 2.705-5.77 2.705z"></path>
          <path d="m348.201 185.411c-2.04 0-4.072-.827-5.552-2.455l-53.81-59.197c-2.786-3.065-2.56-7.809.505-10.595 3.066-2.784 7.81-2.559 10.595.505l53.81 59.197c2.786 3.065 2.56 7.809-.505 10.595-1.438 1.305-3.243 1.95-5.043 1.95z"></path>
          <path d="m377.716 187.594c-2.397 0-4.752-1.146-6.205-3.277l-47.304-69.414c-2.333-3.423-1.449-8.089 1.974-10.421 3.425-2.332 8.089-1.449 10.421 1.974l47.304 69.414c2.333 3.423 1.449 8.089-1.974 10.421-1.291.88-2.761 1.303-4.216 1.303z"></path>
        </g>
        <path
          d="m108.672 226.21c-3.415-1.453-6.704-3.219-9.822-5.294-17.64-11.734-37.23-20.421-57.959-25.603l-39.521-9.88c-1.081-.27-1.832 1.055-1.044 1.843l47.874 47.874c10.698 10.698 10.698 28.044 0 38.743l-47.873 47.873c-.788.788-.038 2.114 1.044 1.844l39.52-9.88c20.729-5.182 40.319-13.87 57.959-25.603 3.714-2.47 7.672-4.505 11.795-6.093z"
          fill="#6cabca"
        ></path>
        <path
          d="m307.006 367.487 16.767 40.697c.324.787 1.318 1.036 1.975.494l9.343-7.701c22.819-18.809 36.036-46.833 36.036-76.405l-55.63 22.648c-7.956 3.239-11.763 12.326-8.491 20.267z"
          fill="#6cabca"
        ></path>
        <path
          d="m511.034 300.063-.423-2.536c-13.119-78.714-81.222-136.406-161.022-136.406h-25.164c-55.737 0-109.006 19.901-150.729 55.162-11.338 9.582-25.673 14.889-40.518 14.889-8.453 0-16.798-1.681-24.506-4.961-7.271 2.041-12.603 8.72-12.603 16.643v22.107c0 8.624 6.317 15.773 14.576 17.073 7.15-2.753 14.797-4.162 22.534-4.162 14.845 0 29.18 5.307 40.518 14.889 41.723 35.261 94.993 55.162 150.729 55.162h45.863c46.222 0 91.41-13.682 129.87-39.321l10.092-6.728c.594-.397.901-1.106.783-1.811z"
          fill="#b4d2e2"
        ></path>
        <path
          d="m511.034 300.063-.423-2.536c-10.161-60.967-53.308-109.323-109.327-128.028 35.326 24.409 60.775 62.523 68.272 107.501.375 2.249-.604 4.509-2.501 5.773l-7.953 5.302c-38.46 25.639-83.648 39.321-129.87 39.321h-45.862c-28.881 0-57.098-5.344-83.391-15.399 36.797 23.174 79.831 35.926 124.446 35.926h45.863c46.222 0 91.41-13.682 129.87-39.321l10.092-6.728c.595-.397.902-1.106.784-1.811z"
          fill="#8abbd5"
        ></path>
        <path
          d="m402.978 324.353c-2.839 0-5.555-1.62-6.819-4.368-6.094-13.253-9.184-27.421-9.184-42.113 0-27.383 10.785-53.007 30.367-72.152 2.961-2.895 7.71-2.842 10.606.12s2.842 7.71-.12 10.606c-16.672 16.299-25.854 38.113-25.854 61.426 0 12.514 2.628 24.573 7.812 35.846 1.73 3.764.083 8.218-3.681 9.948-1.013.465-2.079.687-3.127.687z"
          fill="#8abbd5"
        ></path>
        <path
          d="m396.159 319.985c1.264 2.748 3.979 4.368 6.819 4.368 1.048 0 2.114-.222 3.128-.688 3.763-1.73 5.411-6.185 3.681-9.948-.081-.176-.161-.353-.241-.529-4.721 1.724-9.496 3.296-14.317 4.712.302.698.612 1.392.93 2.085z"
          fill="#6cabca"
        ></path>
        <path
          d="m455.787 289.299c-3.93-1.312-8.176.813-9.487 4.743-1.31 3.93.814 8.178 4.744 9.487l37.318 12.439c3.996-2.334 7.93-4.79 11.796-7.367l4.513-3.009z"
          fill="#8abbd5"
        ></path>
        <path
          d="m456.751 289.621c-3.557 2.31-7.171 4.52-10.835 6.626-.073 3.204 1.929 6.217 5.128 7.283l37.318 12.439c3.996-2.334 7.93-4.79 11.796-7.367l4.513-3.009z"
          fill="#6cabca"
        ></path>
        <path
          d="m324.219 318.068c-29.473 0-58.343-3.252-86.011-9.698-4.034-.94-6.542-4.973-5.602-9.007.939-4.033 4.97-6.538 9.006-5.603 30.82 7.181 63.222 10.224 96.314 9.065 4.142-.145 7.614 3.092 7.759 7.23.146 4.14-3.091 7.614-7.231 7.76-4.759.169-9.505.253-14.235.253z"
          fill="#bad6e5"
        ></path>
        <path
          d="m324.513 280.703c-51.749 0-102.558-3.453-143.703-9.789-4.094-.631-6.901-4.461-6.271-8.555s4.459-6.896 8.554-6.271c41.979 6.465 94.329 9.892 147.358 9.6h.04c4.124 0 7.478 3.332 7.499 7.461.021 4.143-3.319 7.518-7.461 7.539-2.004.01-4.015.015-6.016.015z"
          fill="#bad6e5"
        ></path>
        <path
          d="m181.882 253.054c-3.638 0-6.832-2.651-7.403-6.358-.631-4.094 2.177-7.924 6.271-8.555 41.004-6.319 92.029-9.799 143.675-9.799h33.439c5.26 0 10.642.186 15.999.551 4.133.281 7.254 3.86 6.972 7.993-.282 4.132-3.863 7.245-7.993 6.972-5.018-.342-10.058-.516-14.978-.516h-33.439c-50.906 0-101.119 3.418-141.391 9.623-.387.06-.772.089-1.152.089z"
          fill="#bad6e5"
        ></path>
        <path
          d="m238.594 215.789c-3.396 0-6.473-2.322-7.291-5.771-.956-4.03 1.536-8.072 5.566-9.028 28-6.641 57.458-10.008 87.555-10.008h29.303c13.514 0 26.991 1.435 40.056 4.265 4.048.877 6.62 4.869 5.743 8.918-.876 4.048-4.871 6.622-8.917 5.742-12.024-2.604-24.433-3.925-36.881-3.925h-29.303c-28.933 0-57.226 3.231-84.093 9.604-.582.137-1.165.203-1.738.203z"
          fill="#bad6e5"
        ></path>
        <path
          d="m218.076 268.076h-5.537l60.711 24.285c6.687 2.675 12.761 6.68 17.854 11.772 4.13 4.13 9.732 6.451 15.573 6.451h47.554-7.085c-11.738 0-21.254-9.516-21.254-21.254 0-11.735 9.51-21.249 21.244-21.254z"
          fill="#6cabca"
        ></path>
        <path
          d="m354.231 325.168c-4.004 0-7.275-3.138-7.489-7.088-15.669-.218-28.35-13.031-28.35-28.751 0-15.721 12.68-28.535 28.35-28.751.214-3.95 3.485-7.087 7.489-7.087 4.142 0 7.5 3.357 7.5 7.5 0 8.042-6.542 14.584-14.584 14.584-7.584 0-13.754 6.17-13.754 13.754s6.17 13.754 13.754 13.754c8.042 0 14.584 6.543 14.584 14.585 0 4.143-3.358 7.5-7.5 7.5z"
          fill="#8abbd5"
        ></path>
      </g>
    </svg>
  ),
  sardine: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      {...props}
    >
      <g>
        <g>
          <g>
            <path
              d="m227.532 197.734-24.56-21.661c-2.904-2.561-4.181-6.493-3.325-10.267 2.009-8.852 6.276-26.2 12.726-45.107 2.325-6.814 10.676-9.328 16.421-4.981l17.833 13.493z"
              fill="#b7eaff"
            ></path>
            <g>
              <g>
                <g fill="#b7eaff">
                  <path d="m209.952 355.12s-19.995-13.009-33.654-38.465c-3.794-7.071 1.294-15.636 9.326-15.636h28.691z"></path>
                  <path d="m200.445 9.205 56.085 77.305 56.085-77.305c-22.349-20.753-45.826-2.864-56.085 19.143-10.528-21.742-33.712-40.048-56.085-19.143z"></path>
                  <path d="m305.483 339.138s26.123-24.401 38.904-55.043c1.9-4.556.473-9.818-3.525-12.719l-52.437-38.057z"></path>
                </g>
                <path
                  d="m201.305 411.141c0-136.691 32.633-279.284 47.729-337.934 2.095-8.138 13.603-8.286 15.904-.204 15.456 54.288 46.819 183.499 46.819 338.138 0 41.161-26.548 77.077-42.831 95.234-6.658 7.424-18.279 7.517-25.028.175-16.303-17.732-42.593-52.917-42.593-95.409z"
                  fill="#56b6de"
                ></path>
                <path
                  d="m264.937 73.003c-2.301-8.082-13.809-7.934-15.904.204-3.368 13.084-7.608 30.345-12.164 50.785 15.498 66.412 33.679 169.41 33.679 287.149 0 34.955-19.146 66.126-34.891 85.852 2.898 3.587 5.691 6.785 8.24 9.558 6.749 7.341 18.37 7.249 25.028-.175 16.282-18.157 42.831-54.073 42.831-95.234-.001-154.64-31.363-283.851-46.819-338.139z"
                  fill="#3baad9"
                ></path>
                <g>
                  <path
                    d="m268.426 428.048c-9.943 0-9.959 15.453 0 15.453 9.943-.001 9.96-15.453 0-15.453z"
                    fill="#147da9"
                  ></path>
                </g>
              </g>
            </g>
            <g>
              <path
                d="m260.114 372.616v-46.61c0-8.205-9.932-12.314-15.741-6.512-13.038 13.023-16.133 32.978-7.65 49.331l2.056 3.941c3.438-.865 7.029-1.337 10.736-1.363 4.021-.03 7.544.446 10.599 1.213z"
                fill="#b7eaff"
              ></path>
            </g>
          </g>
          <path
            d="m241.357 379.127c5.897-.062 11.658 1.516 16.362 4.467 2.724 1.709 6.188 1.682 8.803-.19 4.438-3.176 4.375-9.867-.199-12.844-5.333-3.472-13.437-6.887-24.682-6.887-.13 0-.263.001-.394.001-15.431.109-29.407 6.948-39.453 17.87-.32 9.873-.489 19.75-.489 29.595 0 2.465.089 4.906.259 7.32 2.014-21.909 19.091-39.185 39.793-39.332z"
            fill="#147da9"
          ></path>
        </g>
        <g>
          <g>
            <path
              d="m394.307 314.266-24.56 21.661c-2.904 2.561-4.181 6.493-3.325 10.267 2.009 8.852 6.276 26.2 12.726 45.107 2.325 6.814 10.676 9.328 16.421 4.981l17.833-13.493z"
              fill="#b7eaff"
            ></path>
            <g>
              <g>
                <g fill="#b7eaff">
                  <path d="m376.727 156.88s-19.995 13.009-33.654 38.465c-3.794 7.071 1.294 15.636 9.326 15.636h28.691z"></path>
                  <path d="m367.22 502.795 56.085-77.305 56.085 77.305c-22.349 20.753-45.826 2.864-56.085-19.143-10.528 21.743-33.712 40.048-56.085 19.143z"></path>
                  <path d="m472.258 172.862s26.123 24.401 38.904 55.043c1.9 4.556.473 9.818-3.525 12.719l-52.437 38.057z"></path>
                </g>
                <path
                  d="m368.08 100.859c0 136.691 32.633 279.284 47.729 337.934 2.095 8.138 13.603 8.286 15.904.204 15.456-54.288 46.819-183.499 46.819-338.138 0-41.161-26.548-77.077-42.831-95.234-6.658-7.424-18.279-7.517-25.028-.175-16.303 17.732-42.593 52.917-42.593 95.409z"
                  fill="#56b6de"
                ></path>
                <path
                  d="m435.7 5.625c-6.658-7.424-18.279-7.517-25.028-.176-2.549 2.772-5.341 5.971-8.239 9.558 15.745 19.725 34.891 50.897 34.891 85.852 0 117.739-18.181 220.737-33.679 287.149 4.556 20.441 8.796 37.702 12.164 50.785 2.095 8.138 13.603 8.286 15.904.204 15.456-54.288 46.819-183.499 46.819-338.138-.002-41.161-26.55-77.077-42.832-95.234z"
                  fill="#3baad9"
                ></path>
                <g>
                  <path
                    d="m435.201 83.952c-9.943 0-9.959-15.453 0-15.453 9.943.001 9.96 15.453 0 15.453z"
                    fill="#147da9"
                  ></path>
                </g>
              </g>
            </g>
            <g>
              <path
                d="m426.889 139.385v46.61c0 8.205-9.932 12.314-15.741 6.512-13.038-13.023-16.133-32.978-7.65-49.331l2.056-3.941c3.438.865 7.029 1.337 10.736 1.363 4.021.029 7.544-.447 10.599-1.213z"
                fill="#b7eaff"
              ></path>
            </g>
          </g>
          <path
            d="m408.132 132.873c5.897.062 11.658-1.516 16.362-4.467 2.725-1.709 6.188-1.682 8.803.19 4.438 3.176 4.375 9.867-.199 12.844-5.334 3.472-13.437 6.886-24.682 6.886-.13 0-.263-.001-.394-.001-15.431-.109-29.407-6.948-39.453-17.87-.32-9.873-.49-19.75-.49-29.595 0-2.465.089-4.906.259-7.32 2.015 21.91 19.092 39.186 39.794 39.333z"
            fill="#147da9"
          ></path>
        </g>
        <g>
          <g>
            <path
              d="m117.693 314.266 24.56 21.661c2.904 2.561 4.181 6.493 3.325 10.267-2.009 8.852-6.276 26.2-12.726 45.107-2.325 6.814-10.676 9.328-16.421 4.981l-17.833-13.493z"
              fill="#b7eaff"
            ></path>
            <g>
              <g>
                <g fill="#b7eaff">
                  <path d="m135.273 156.88s19.995 13.009 33.654 38.465c3.794 7.071-1.294 15.636-9.326 15.636h-28.691z"></path>
                  <path d="m144.78 502.795-56.085-77.305-56.085 77.305c22.349 20.753 45.826 2.864 56.085-19.143 10.528 21.743 33.712 40.048 56.085 19.143z"></path>
                  <path d="m39.742 172.862s-26.123 24.401-38.904 55.043c-1.9 4.556-.473 9.818 3.525 12.719l52.437 38.057z"></path>
                </g>
                <path
                  d="m143.92 100.859c0 136.691-32.633 279.284-47.729 337.934-2.095 8.138-13.603 8.286-15.904.204-15.455-54.288-46.817-183.499-46.817-338.138 0-41.161 26.548-77.077 42.831-95.234 6.658-7.424 18.279-7.517 25.028-.175 16.301 17.732 42.591 52.917 42.591 95.409z"
                  fill="#56b6de"
                ></path>
                <path
                  d="m101.328 5.45c-6.749-7.341-18.37-7.249-25.028.175-2.455 2.738-5.144 5.88-7.94 9.382 15.64 19.355 34.353 50.002 34.353 85.852 0 106.198-19.697 215.959-35.565 287.149 4.857 20.814 9.451 38.035 13.139 50.989 2.301 8.082 13.809 7.934 15.904-.204 15.096-58.651 47.729-201.243 47.729-337.934 0-42.492-26.29-77.677-42.592-95.409z"
                  fill="#3baad9"
                ></path>
                <g>
                  <path
                    d="m76.799 83.952c9.943 0 9.959-15.453 0-15.453-9.943.001-9.96 15.453 0 15.453z"
                    fill="#147da9"
                  ></path>
                </g>
              </g>
            </g>
            <g>
              <path
                d="m85.111 139.385v46.61c0 8.205 9.932 12.314 15.741 6.512 13.038-13.023 16.133-32.978 7.65-49.331l-2.056-3.941c-3.438.865-7.029 1.337-10.736 1.363-4.021.029-7.544-.447-10.599-1.213z"
                fill="#b7eaff"
              ></path>
            </g>
          </g>
          <path
            d="m103.868 132.873c-5.897.062-11.658-1.516-16.362-4.467-2.725-1.709-6.188-1.682-8.803.19-4.438 3.176-4.375 9.867.199 12.844 5.334 3.472 13.437 6.886 24.682 6.886.13 0 .263-.001.394-.001 15.431-.109 29.407-6.948 39.453-17.87.32-9.873.49-19.75.49-29.595 0-2.465-.089-4.906-.259-7.32-2.015 21.91-19.092 39.186-39.794 39.333z"
            fill="#147da9"
          ></path>
        </g>
      </g>
    </svg>
  ),
  fish1: (props) => (
    <svg
      viewBox="0 0 75 75"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="_x33_3">
        <g>
          <path
            d="m32.0696411 48.4436264c-.7010307 1.2783508-7.8454094 4.0103531-10.5361366 11.7320557-1.2886696 3.6907043-1.9072685 6.4330292-2.1958981 8.2990189-.1649227 1.0618286-1.5360851 1.4020615-2.1752605.5257874-3.0876303-4.2882614-6.0317421-9.8345299-6.5464802-15.0722771 6.6598682 2.969101 8.3196602.4536133 4.9691181-7.5361366.1033812.0124092 3.5046673 1.5029411 10.0310497.8969078 6.5773144-.6289178 7.1649533-.1340257 6.4536076 1.1546439z"
            fill="#417893"
          ></path>
        </g>
        <g>
          <path
            d="m32.0696411 48.4436264c-.7010307 1.2783508-7.8454094 4.0103531-10.5361366 11.7320557-1.2886696 3.6907043-1.9072685 6.4330292-2.1958981 8.2990189-.1649227 1.0618286-1.5360851 1.4020615-2.1752605.5257874-.9278679-1.2886658-2.0618715-3.010376-3.1340847-4.9794388 1.4123774-1.0412521 2.4536324-2.5979767 2.8660316-4.319622.4123363-1.6907501.3504829-3.7216644 1.7113266-4.8144531 1.0722122-.8660126 2.7938576-.8660126 3.5464211-2.0309753.6391754-.9690819.2474155-2.2474327-.1030674-3.350544-.2061996-.6391754-.3711224-1.3195648-.3195877-1.9896965 0-.0308952.0103188-.0618553.0103188-.0927505 1.1443233.0308952 2.4329929 0 3.8763294-.1340256 6.5773143-.6289179 7.1649532-.1340258 6.4536075 1.1546438z"
            fill="#8fc2d5"
          ></path>
        </g>
        <g>
          <g>
            <g>
              <path
                d="m67.080246 12.6804562c-1.9381638 1.9793797-6.5670586 5.2680664-10.5670929 8.597971-4.260849 3.5794868-26.7655106 16.4709854-34.7734489 18.1857224-8.7217398 2.4536324-6.1547203 6.9279251-6.1547203 6.9279251-10.1558281-7.0670358.6020393-28.6726667 14.7836494-34.6703817 14.3712501-6.0928659 22.4434318-5.8557081 30.7425155-6.185615 8.2887001-.3299069 7.4639626 1.7113256 7.4639626 1.7113256-1.8763046 1.2989898-2.8041763 3.8041558-2.8247528 3.8763289.0927505-.0515337 1.6701126-.9072285 1.9587402-1.8144569.2990112-.9278049.8865891-1.2473926.8865891-1.2473926.639244.9690199.4227218 2.6288748-1.5154419 4.6185732z"
                fill="#8fc2d5"
              ></path>
            </g>
            <g>
              <path
                d="m56.7296715 19.0104179s-.5567474 1.2783508-1.3814812 3.1443424c-6.4218407 4.5870075-26.1593895 15.7143154-33.6084862 17.3093891-8.7217398 2.4536324-6.1547203 6.9279251-6.1547203 6.9279251-.2370949-.1649857-.4741898-.340229-.6907091-.5361099-5.5154819-9.1959305 14.226903-14.5774479 23.7424202-20.4950104 9.7114601-6.0309486 8.1826324-6.6895218 9.8557434-9.4743023 1.3430023-2.2353373 4.4742928-5.0516109 4.4742928-5.0516109-2.9672423 2.7822676-2.9983206 8.579134 3.7629404 8.1753769z"
                fill="#c9e9f4"
              ></path>
            </g>
            <g>
              <path
                d="m30.3583126 11.721693c-4.4330101 1.9072065-8.288702 5.0412292-11.680521 9.175293-.1029987.0414028-3.3538771 1.3481731-3.1546612 1.2680931 1.2474556-3.9278641-.2886295-8.3402996-.2886295-8.3402996 7.3820667-3.0000019 15.0238113-2.0946979 15.1238117-2.1030865z"
                fill="#417893"
              ></path>
            </g>
            <g>
              <path
                d="m22.7912159 11.8969345c-.5096397 1.2233839-1.6531601 1.6795778-2.7629013 2.3711405-3.6411171 2.2690554-.3228664 4.1926966-2.6185532 7.1443777l-1.886631.7526264c1.2474556-3.9278641-.2886295-8.3402996-.2886295-8.3402996 2.5875969-1.0515747 5.2268524-1.618577 7.556715-1.927845z"
                fill="#8fc2d5"
              ></path>
            </g>
            <g>
              <path
                d="m52.5337563 33.5775452c-.0499039-.1011467-4.0656013-8.2410545-3.814476-7.7320175 0 0 2.0206566-4.2680893 5.1443596-5.6598911.0021591.1001071 2.1076278 9.1902904-1.3298836 13.3919086z"
                fill="#417893"
              ></path>
            </g>
            <g>
              <path
                d="m54.5028152 26.0207691c.0206375 2.659832-.3917618 5.62887-1.969059 7.556776l-2.1134071-4.2784081c.766777-.0697842 1.7594681.3238468 2.4638901-.1649837.9203377-.6346416.5666008-2.1918545 1.5567207-3.0618496.0206414-.0206393.0412789-.0309581.0618553-.0515346z"
                fill="#8fc2d5"
              ></path>
            </g>
            <g>
              <path
                d="m30.6263676 35.8455544c-.0565891.1024094-4.5818863 9.8242645-6.5773773 10.1959724-2.0103378.3917618-1.4536552-1.7629242-.5361061-3.8041573.9233112-2.047554.6767406-3.6731949.6907101-3.7731972z"
                fill="#417893"
              ></path>
            </g>
            <g>
              <path
                d="m28.2861214 40.4538727c-1.4330158 2.5979156-3.1855564 5.3917732-4.2371311 5.5876541-2.0103378.3917618-1.4536552-1.7629242-.5361061-3.8041573.2370949-.5257874.4020805-1.0206146.5051479-1.4845505.1855621 0 .3711853.0206413.5051479.1649857.1649857.1752434.1753044.4432945.1546669.6803894-.0972862 1.2011032-.3165722 1.4300079-.2267761 1.8247795.0618534.2267761.2886295.4329758.5154686.3711205.2061367-.0515327.309267-.2886925.3917599-.4845734.5463638-1.2680321 1.7216453-2.1546211 2.9278221-2.855648z"
                fill="#8fc2d5"
              ></path>
            </g>
            <g>
              <g>
                <path
                  d="m11.8577795 53.7546692c1.4712992 3.4687767 3.9851513 9.8757133 6.1684275 13.3857422-2.5033541-3.3290138-4.9489127-9.4551811-6.1684275-13.3857422z"
                  fill="#150e08"
                ></path>
              </g>
              <g>
                <path
                  d="m11.9807959 52.92453c1.8467989 3.1871605 4.7873259 8.5609512 7.4447031 11.1551514-2.9649525-2.3962593-5.9107342-7.6826324-7.4447031-11.1551514z"
                  fill="#150e08"
                ></path>
              </g>
              <g>
                <path
                  d="m11.5951757 49.9046326c.6123352 1.0401306 1.2581482 2.0576477 1.9127197 3.067749 2.1535692 3.2839699 4.0186701 5.7635727 6.6107492 8.5609131-.8979492-.8059082-1.7634583-1.6548462-2.5546875-2.5702209-2.4462842-2.8019868-4.6374043-6.2212373-5.9687814-9.0584412z"
                  fill="#150e08"
                ></path>
              </g>
              <g>
                <path
                  d="m12.2932959 49.2059021c.6618652.8288574 1.3507996 1.6326294 2.0464172 2.4286499 2.6106882 2.9619408 4.5023336 4.7195816 6.7923899 6.6460266-.8780823-.5938721-1.7407227-1.2197876-2.5408325-1.920105-2.2814961-1.9456443-4.7176486-4.6752052-6.2979746-7.1545715z"
                  fill="#150e08"
                ></path>
              </g>
              <g>
                <path
                  d="m12.8271704 48.1257935c3.6728716 2.6884956 7.3770685 5.6069221 9.7488108 7.4179382-3.2548028-2.0058937-7.338934-5.1942291-9.7488108-7.4179382z"
                  fill="#150e08"
                ></path>
              </g>
              <g>
                <path
                  d="m13.1570044 47.0172119c.909729.572052 1.8422852 1.1022034 2.7801819 1.617981 2.8749704 1.5565948 5.7016459 2.8336678 8.9250803 3.5100708-1.0692444-.1104431-2.1312256-.3249817-3.1647034-.6377563-3.155838-.9831734-6.3255663-2.7527276-8.5405588-4.4902955z"
                  fill="#150e08"
                ></path>
              </g>
              <g>
                <path
                  d="m13.1037817 45.336853c1.1452637.6375122 2.3349609 1.1861267 3.5377512 1.6903687 3.570385 1.4602432 7.7605286 2.5794067 11.3580017 1.0985718-1.1703491.6030273-2.4891357.8890381-3.8109131.9305725-1.3273621.0518494-2.639801-.1938171-3.9214783-.4911499-2.5506896-.6748658-4.9766855-1.7812195-7.1633615-3.2283631z"
                  fill="#150e08"
                ></path>
              </g>
            </g>
            <g>
              <path
                d="m18.5955925 20.9273052s-.0067711.0305424-.0203552.0950031v.0033741c-7.1177158 8.8547592-9.9234219 20.6237698-2.9922953 25.3632526 0 0 4.6309385 7.0125465.3969517 8.7224426-4.2374039 1.7098732-5.3671322-1.184021-5.3671322-1.184021s-4.6716485-6.965065-4.4239936-15.4025192c.2442799-8.4340553 9.7911263-18.852808 9.7911263-18.852808-.0576897.854948-.2069654 1.6861439-.4614124 2.4935913z"
                fill="#629abd"
              ></path>
            </g>
            <g>
              <path
                d="m7.1307702 45.9295807s-1.4281187 3.2297363-.9515119 4.7197876c.4766068 1.4900475.8445201 1.6372147.8445201 1.6372147l1.4233155-2.5598755z"
                fill="#417893"
              ></path>
            </g>
            <g>
              <path
                d="m58.7981796 8.8269358c-.1045227 1.1542358-.4093933 2.2981873-.8553467 3.3725586-.3632813 1.0386658-.5181885 2.2436218-.1784058 3.2703247.280426 1.1087046 1.5378418 1.463685 2.625946 1.2393198 1.1248779-.153595 2.181427-.6558533 3.2553101-1.0805368-1.0013733.5722971-2.02948 1.1539927-3.2030945 1.3837595-.2901917.0603333-.5950012.0700378-.8938599.0973206-.3002014-.0614014-.6204834-.0229187-.9056396-.1791077-.6017151-.1957397-1.0791931-.7399902-1.2561035-1.3297129-.34729-1.1908569-.1759033-2.4179382.2739868-3.5211792.4984742-1.0362855.868805-2.1246338 1.1372071-3.2527466z"
                fill="#191011"
              ></path>
            </g>
            <g>
              <path
                d="m67.080246 12.6804562c-1.9381638 1.9793797-6.5670586 5.2680664-10.5670929 8.597971-4.3456421 3.6507187-26.8197136 16.4825897-34.7734489 18.1857224 2.8709641-3.9002495 5.1871815-4.3472252 21.7011871-14.6598778 6.8763275-4.2887287 7.5876732-10.2784634 7.5876732-10.2784634-.0974312 1.939188.7383194 3.1289177 1.788578 3.8547707 1.5676651 1.0834427 3.6602974 1.0399952 5.2873878.048027 1.9746552-1.2038631 4.9818115-3.1594133 5.7798386-4.3564119 1.2268143-1.8247137 1.8659897-2.9484615 1.8659897-2.9484615.0927505-.0515337 1.6701126-.9072285 1.9587402-1.8144569.2990112-.9278051.8865891-1.2473928.8865891-1.2473928.639244.9690199.4227218 2.6288748-1.5154419 4.6185732z"
                fill="#c9e9f4"
              ></path>
            </g>
            <g>
              <path
                d="m54.218132 9.5620127c-1.4895134 1.5522909-3.6336975 4.1976099-3.039978 6.2671509.3702087 1.1053782 1.1499329 2.1386423 2.1933594 2.7112436 1.053833.5714722 2.3440857.6776733 3.5489807.4193115-1.1665649.4092102-2.521759.4025574-3.6842651-.1557922-1.1743774-.5632019-1.9930725-1.652832-2.4362488-2.865449-.6221924-2.2756862 1.5584869-4.9137344 3.4181518-6.3764648z"
                fill="#191011"
              ></path>
            </g>
            <g>
              <path
                d="m68.5751114 7.2474036s-4.9279022-1.0721507-15.0310593.2268386c-4.6392136.5978975-7.0928459.9072285-17.8970337 6.2474689-12.0207462 5.938201-23.134203 17.0001221-23.979578 22.6599541.8556948-9.0310097 8.866024-20.5053329 18.7011929-24.6599712 14.3712501-6.0928669 22.4434318-5.8557091 30.7425155-6.185616 8.2887001-.329907 7.4639626 1.7113256 7.4639626 1.7113256z"
                fill="#5085a5"
              ></path>
            </g>
          </g>
          <g>
            <path
              d="m30.3643055 11.7158175c-3.3888435-.2120047-7.8575535.1835623-11.4199219 1.1098633-1.1800537.2900391-2.3300781.6899414-3.4799814 1.1098633.7776194 2.5673761.9874067 5.478343.2099609 8.0703115l3.000001-1.1103516c-.1017952.0442829-3.5177097 1.5302734-3.3100595 1.4399414l.0600586-.199707c.3900146-1.340332.5-2.7602539.3999023-4.1503906-.1628008-2.5181093-.8041372-4.1695232-.829834-4.2695303l.1699219-.0703125c1.1999521-.4697266 2.4299326-.8999023 3.6899424-1.1899414 3.8722438-.9604989 8.022068-1.1638632 11.5100097-.7397461z"
              fill="#150e08"
            ></path>
          </g>
        </g>
        <g>
          <path
            d="m68.5751114 7.2474036c-1.8763046 1.2989898-2.8041763 3.8041558-2.8247528 3.8763289 0 0-.9175491 2.7422619-2.1031494 3.0412741-1.1855354.309268-1.164959-.4432955-.927803-1.8144579.2474136-1.3814812 4.4070587-5.3078346 4.4070587-5.3078346.5561752.0655346 1.0779647.1323281 1.4486465.2046895z"
            fill="#629abd"
          ></path>
        </g>
        <g>
          <path
            d="m63.4526749 9.7830915c.7626572-.4012222 1.3937683-.7810593 1.6052246-1.6578217.0153275-.0635481.0273132-.1316261.0052872-.1931753-.0644608-.180162-.3972397-.2517328-.7635651.1175613-.1239548.124958-.2298584.2677355-.3619347.3840799-.2391853.2107048-.5475388.3212843-.8443756.4374542-.3931389.1538601-.4520683.313612-.3986511.5873756.027462.1407461.0835571.4541521.2263298.5281553.1452866.0753043.4087677-.1389635.5316849-.2036293z"
            fill="#629abd"
          ></path>
        </g>
        <g>
          <g>
            <path
              d="m60.4255524 8.1306458c.7000008-.6962142 1.9134865-.8983574 2.7098351-.4502172s.8744774 1.3771296.1744728 2.0733433c-.7000008.6962147-1.9147148.897665-2.7110634.4495249s-.8732453-1.3764373-.1732445-2.072651z"
              fill="#150e08"
            ></path>
          </g>
          <g>
            <path
              d="m60.6571083 8.260952c.5876083-.5844274 1.6062546-.7541137 2.2747383-.3779287.6684837.3761854.734066 1.1560144.1464577 1.7404423-.5876045.5844278-1.6072845.7535324-2.2757683.377347-.6684837-.3761845-.7330322-1.1554328-.1454277-1.7398606z"
              fill="#f9cf6b"
            ></path>
          </g>
          <g>
            <path
              d="m61.0717926 8.4943123c.3902168-.3881054 1.0666771-.5007906 1.5106049-.2509737.443924.2498159.4874763.767684.0972595 1.1557903-.3902168.3881054-1.0673637.5004053-1.5112915.2505884-.443924-.2498169-.4867897-.7672987-.0965729-1.155405z"
              fill="#150e08"
            ></path>
          </g>
          <g>
            <path
              d="m61.9086151 9.201005c.2658043-.1271162.35075-.4152164.4814987-.2304583s.0210876.4379311-.2447166.5650473c-.2658081.1271162-.5877342.0803404-.718483-.1044168-.1307487-.1847582.2158928-.103057.4817009-.2301722z"
              fill="#fff"
            ></path>
          </g>
          <g>
            <ellipse
              cx="61.438"
              cy="8.243"
              fill="#fff"
              rx=".383"
              ry=".289"
              transform="matrix(.98 -.198 .198 .98 -.416 12.325)"
            ></ellipse>
          </g>
        </g>
        <g opacity=".4">
          <g>
            <ellipse
              cx="8.317"
              cy="40.655"
              fill="#173569"
              rx="1.743"
              ry="1.459"
              transform="matrix(.111 -.994 .994 .111 -33.01 44.416)"
            ></ellipse>
          </g>
          <g>
            <ellipse
              cx="11.854"
              cy="48.246"
              fill="#173569"
              rx=".747"
              ry=".896"
              transform="matrix(.643 -.766 .766 .643 -32.718 26.303)"
            ></ellipse>
          </g>
          <g>
            <g>
              <ellipse
                cx="33.731"
                cy="27.722"
                fill="#173569"
                rx="2.422"
                ry="2.027"
                transform="matrix(.111 -.994 .994 .111 2.443 58.173)"
              ></ellipse>
            </g>
            <g>
              <ellipse
                cx="48.422"
                cy="22.372"
                fill="#173569"
                rx="1.596"
                ry="1.336"
                transform="matrix(.673 -.74 .74 .673 -.706 43.149)"
              ></ellipse>
            </g>
            <g>
              <ellipse
                cx="49.241"
                cy="14.964"
                fill="#173569"
                rx=".989"
                ry=".828"
                transform="matrix(.673 -.74 .74 .673 5.043 41.331)"
              ></ellipse>
            </g>
            <g>
              <ellipse
                cx="33.367"
                cy="21.602"
                fill="#173569"
                rx=".711"
                ry=".595"
                transform="matrix(.673 -.74 .74 .673 -5.063 31.758)"
              ></ellipse>
            </g>
            <g>
              <ellipse
                cx="29.352"
                cy="33.578"
                fill="#173569"
                rx=".932"
                ry=".78"
                transform="matrix(.673 -.74 .74 .673 -15.238 32.706)"
              ></ellipse>
            </g>
            <g>
              <ellipse
                cx="41.097"
                cy="26.195"
                fill="#173569"
                rx=".919"
                ry=".769"
                transform="matrix(.673 -.74 .74 .673 -5.932 38.98)"
              ></ellipse>
            </g>
            <g>
              <ellipse
                cx="41.383"
                cy="17.396"
                fill="#173569"
                rx="1.331"
                ry="1.11"
                transform="matrix(.257 -.967 .967 .257 13.952 52.93)"
              ></ellipse>
            </g>
            <g>
              <ellipse
                cx="22.19"
                cy="35.778"
                fill="#173569"
                rx="1.837"
                ry="1.535"
                transform="matrix(.651 -.759 .759 .651 -19.412 29.317)"
              ></ellipse>
            </g>
            <g>
              <ellipse
                cx="16.509"
                cy="33.194"
                fill="#173569"
                rx="1.178"
                ry=".984"
                transform="matrix(.651 -.759 .759 .651 -19.432 24.104)"
              ></ellipse>
            </g>
            <g>
              <ellipse
                cx="45.697"
                cy="9.783"
                fill="#173569"
                rx="1.303"
                ry="1.093"
                transform="matrix(.699 -.715 .715 .699 6.764 35.631)"
              ></ellipse>
            </g>
            <g>
              <ellipse
                cx="33.191"
                cy="14.484"
                fill="#173569"
                rx="1.11"
                ry="1.325"
                transform="matrix(.995 -.097 .097 .995 -1.251 3.295)"
              ></ellipse>
            </g>
            <g>
              <ellipse
                cx="23.39"
                cy="28.407"
                fill="#173569"
                rx=".707"
                ry=".844"
                transform="matrix(.995 -.097 .097 .995 -2.651 2.408)"
              ></ellipse>
            </g>
            <g>
              <ellipse
                cx="24.457"
                cy="21.166"
                fill="#173569"
                rx="1.721"
                ry="1.438"
                transform="matrix(.445 -.895 .895 .445 -5.386 33.637)"
              ></ellipse>
            </g>
          </g>
          <g>
            <ellipse
              cx="11.854"
              cy="28.208"
              fill="#173569"
              rx="1.143"
              ry="1.368"
              transform="matrix(.895 -.445 .445 .895 -11.322 8.231)"
            ></ellipse>
          </g>
        </g>
      </g>
    </svg>
  ),
  fish2: (props) => (
    <svg
      height="464pt"
      viewBox="0 -99 464 464"
      width="464pt"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m392 152-93.785156 46.886719c-33.023438 16.515625-69.4375 25.113281-106.359375 25.113281h-5.335938c-130.519531 0-186.519531-72-186.519531-72l6-12.496094 50 12.496094-48-24c40-48 115.441406-80 178.519531-80 35.214844-.003906 69.992188 7.816406 101.816407 22.894531l103.664062 49.105469zm0 0"
        fill="#e0e0de"
      ></path>
      <path
        d="m318.617188 85.238281c-67.761719 72.121094-188.800782 99.050781-263.015626 109.007813 40.582032 20.382812 85.511719 30.589844 130.917969 29.753906h5.335938c36.9375.003906 73.363281-8.59375 106.402343-25.113281l93.742188-46.886719v-32zm0 0"
        fill="#d6d6d4"
      ></path>
      <path
        d="m392 120-103.664062-49.105469c-31.824219-15.078125-66.601563-22.898437-101.816407-22.894531-63.078125 0-138.519531 32-178.519531 80l16 8h368zm0 0"
        fill="#348fd9"
      ></path>
      <path
        d="m392 120 15.753906-35.449219c9.886719-22.21875 31.925782-36.539062 56.246094-36.550781l-32 88 32 88c-24.320312-.011719-46.359375-14.332031-56.246094-36.550781l-15.753906-35.449219zm0 0"
        fill="#3d4d63"
      ></path>
      <path
        d="m80 128c-8.835938 0-16-7.164062-16-16s7.164062-16 16-16 16 7.164062 16 16-7.164062 16-16 16zm0-16"
        fill="#3d4d63"
      ></path>
      <path
        d="m105.34375 191.015625-7.6875-14.03125 6.296875-3.457031c13.589844-8.0625 21.8125-22.792969 21.542969-38.589844.058594-11.292969-4.042969-22.210938-11.527344-30.664062l-10.402344-11.386719 11.832032-10.773438 10.402343 11.382813c10.21875 11.371094 15.820313 26.152344 15.695313 41.441406.402344 21.675781-11.042969 41.847656-29.855469 52.621094zm0 0"
        fill="#2a71ad"
      ></path>
      <path d="m160 136v24l40 16 64-40zm0 0" fill="#3d4d63"></path>
      <path
        d="m4.421875 135.152344 7.15625-14.308594 63.996094 31.996094-7.15625 14.3125zm0 0"
        fill="#2a71ad"
      ></path>
      <g fill="#ffb531">
        <path d="m186.519531 48c6.273438 0 12.519531.335938 18.753907.800781 6.449218-17.1875 14.882812-33.566406 25.125-48.800781-25.238282 0-49.066407 11.652344-64.558594 31.574219l-17.472656 19.5625c12.613281-2.070313 25.371093-3.117188 38.152343-3.136719zm0 0"></path>
        <path d="m141.816406 234.207031c15.496094 19.921875 39.320313 31.574219 64.558594 31.578125-9.484375-12.742187-16.957031-26.859375-22.160156-41.863281-18.195313-.097656-36.351563-1.757813-54.261719-4.960937zm0 0"></path>
        <path d="m312 248c-10.609375-13.304688-19.847656-27.648438-27.574219-42.808594-11.917969 5.039063-24.226562 9.097656-36.800781 12.136719 15.109375 14.390625 43.214844 30.671875 64.375 30.671875zm0 0"></path>
      </g>
      <path
        d="m359.132812 104.515625 9.664063-20.003906 14.40625 6.960937-9.664063 20.003906zm0 0"
        fill="#3086cd"
      ></path>
      <path
        d="m332.976562 91.503906 9.996094-18.339844 14.050782 7.660157-9.996094 18.339843zm0 0"
        fill="#3086cd"
      ></path>
      <path
        d="m307.8125 79.804688 9.34375-18.996094 14.359375 7.0625-9.34375 18.996094zm0 0"
        fill="#3086cd"
      ></path>
      <path
        d="m312 19.457031c-24.089844 0-46.808594 18.710938-62.304688 37.007813.335938.121094.671876.261718 1.015626.382812 12.339843 3.460938 24.382812 7.921875 36 13.328125 6.921874-17.617187 15.382812-34.589843 25.289062-50.71875zm0 0"
        fill="#ffb531"
      ></path>
      <path
        d="m318.617188 85.238281c-19.796876 20.410157-42.707032 37.542969-67.882813 50.761719h141.265625v-16zm0 0"
        fill="#3086cd"
      ></path>
    </svg>
  ),
};
